import { render, staticRenderFns } from "./FilterToken.vue?vue&type=template&id=310267b4&scoped=true"
import script from "./FilterToken.vue?vue&type=script&lang=ts"
export * from "./FilterToken.vue?vue&type=script&lang=ts"
import style0 from "./FilterToken.vue?vue&type=style&index=0&id=310267b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310267b4",
  null
  
)

export default component.exports